/**
 * Grade Modal - Download PDF com captura de email
 * @package MentoriaLeiSeca
 */

export default function initGradeModal() {
    const openBtn = document.getElementById('openGradeModal');
    const modal = document.getElementById('gradeModal');
    
    if (!openBtn || !modal) {return;}
    
    const overlay = modal.querySelector('.grade-modal__overlay');
    const closeButtons = modal.querySelectorAll('.grade-modal__close');
    const formState = document.getElementById('gradeModalForm');
    const successState = document.getElementById('gradeModalSuccess');
    const form = document.getElementById('gradeEmailForm');
    const submitBtn = form?.querySelector('button[type="submit"]');
    let lastFocusedElement = null;
    let removeFocusTrap = null;
    
    // Abrir modal
    openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
    });
    
    // Fechar modal - overlay
    overlay?.addEventListener('click', closeModal);
    
    // Fechar modal - botões X
    closeButtons.forEach(btn => {
        btn.addEventListener('click', closeModal);
    });
    
    // Fechar modal - ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
            closeModal();
        }
    });
    
    // Submit form
    form?.addEventListener('submit', function(e) {
        e.preventDefault();
        handleFormSubmit();
    });
    
    function getFocusableElements(container) {
        return Array.from(container.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ));
    }

    function trapFocus(container) {
        const focusable = getFocusableElements(container);
        if (focusable.length === 0) {
            return function () {};
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        function handleKeydown(e) {
            if (e.key !== 'Tab') {return;}

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }

        container.addEventListener('keydown', handleKeydown);

        return function () {
            container.removeEventListener('keydown', handleKeydown);
        };
    }

    function openModal() {
        modal.setAttribute('aria-hidden', 'false');
        modal.setAttribute('aria-labelledby', 'gradeModalTitle');
        modal.setAttribute('aria-describedby', 'gradeModalSubtitle');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        lastFocusedElement = document.activeElement;

        // Reset para estado inicial
        formState.style.display = 'flex';
        successState.style.display = 'none';

        const focusable = getFocusableElements(modal);
        if (focusable.length > 0) {
            focusable[0].focus();
        }

        if (removeFocusTrap) {
            removeFocusTrap();
        }
        removeFocusTrap = trapFocus(modal);
    }
    
    function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        if (removeFocusTrap) {
            removeFocusTrap();
            removeFocusTrap = null;
        }

        if (lastFocusedElement) {
            lastFocusedElement.focus();
            lastFocusedElement = null;
        }
    }
    
    function handleFormSubmit() {
        const formData = new FormData(form);
        formData.append('action', 'mls_grade_download');
        
        // Disable button
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.querySelector('span').textContent = 'Enviando...';
        }
        
        fetch(window.mls_ajax?.ajax_url || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Mostrar estado de sucesso
                formState.style.display = 'none';
                successState.style.display = 'flex';
                modal.setAttribute('aria-labelledby', 'gradeModalSuccessTitle');
                modal.setAttribute('aria-describedby', 'gradeModalSuccessSubtitle');

                const downloadButton = successState.querySelector('.grade-modal__btn--download');
                if (downloadButton) {
                    downloadButton.focus();
                }
            } else {
                alert(data.data?.message || 'Erro ao processar. Tente novamente.');
            }
        })
        .catch(error => {
            console.error('Erro:', error);
            alert('Erro ao processar. Tente novamente.');
        })
        .finally(() => {
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.querySelector('span').textContent = 'Avançar';
            }
        });
    }
}
